import { agendaSlide, basicSlideWithLogo, bulletListSlide, orderedListSlide, tPrework, tPreworkWithLogo } from './SLSprint00'
import { makeSlideDeck } from './SL00000Sprint00'

import { list49200Sprint01 } from '../ActivityLists/AL49200Sprint01'
import { list49200Sprint02 } from '../ActivityLists/AL49200Sprint02'

import { insertInto } from './SLSprintPlanning'
import { sprintPlanningSlideDeck } from './SLSprintPlanning'

// Software Systems Capstone (SSC) sprint 2 global values.
const sprint = 2
const activityListPrevious = () => { return list49200Sprint01(sprint-1) }
const activityList = () => { return list49200Sprint02(sprint) }

// Session 1 of 2: Monday
const ssc_2_1of4_PAaA = {
	'announcements':[ 
		'I have graded and posted your Sprint 1 Planning Assignments' ],
	'prework':[ 
		`Sprint ${sprint-1} assignments were due Sunday`, '',
		`Be prepared for Sprint ${sprint} Planning` ],
	'agenda':[ 
		'Question and Answer Session (Sprint 2 Planning)',
		'Prework for Next Class',
		'Lab' ]
}
const lab = () => { 
	return bulletListSlide('Lab', 
		'Let’s focus on sprint 2 activities and assignments by:', [
		'Deciding how we can best utilize our time today', 
		'Utilizing your precious time together to complete the most valuable activities',
		'Do we want to try hosting a repository from your organization on Azure?' ])
}
export const ssc_2_1of4 = () => { 
	const prework = () => { return tPreworkWithLogo('Prework For Today', ssc_2_1of4_PAaA.prework, sprint-1, activityListPrevious) }
	const announcements =  () => { return basicSlideWithLogo( 'Announcements', ssc_2_1of4_PAaA.announcements) }
	const agenda = () => { return agendaSlide(ssc_2_1of4_PAaA.agenda) }
	const preworkNext = () => { return tPrework('Prework For Next Class', ssc_2_2of4_PAaA.prework, sprint, activityList) }

	const qAndASession = () => {
		return orderedListSlide('Question and Answer Session (Sprint 2 Planning)', 'As a individual or as a team:', [
			`Any questions or comments relating to sprint ${sprint} activities or assignments?`,
			`Any ${sprint} questions or comments?`]
		)
	}

	const slideDeck = makeSlideDeck([ prework, announcements, agenda, qAndASession, preworkNext, lab ])
	const slideDeckWithSprintPlanning = insertInto(slideDeck, sprintPlanningSlideDeck(sprint), 7)
	return slideDeckWithSprintPlanning
}

const ssc_2_2of4_PAaA = {
	'prework': [
		'Be prepared for Lab (attendance required)' ],
	'announcements':[],
	'agenda':[]
}
const ssc_2_2of2 = () => { return [ lab ] } 

// One slide deck for each of the 2 potential class sessions. 
export const ssc_2_slidedeck = [ ssc_2_1of4, ssc_2_2of2 ] 